module.exports = __webpack_public_path__ + "img/migros-carousel.570651ae.png";